export function wrap360(value: number): number {
  return (value + 360) % 360
}
